<template>
  <v-autocomplete
    v-model="textValue"
    :label="label"
    :items="selectItems"
    clearable
  />
</template>
<script>
import _ from 'lodash';

// Derive the IO Site (eProcedures: HU/TA/FE) an Access Location label
// belongs to. The site is encoded in the lookup name text, mirroring the
// ePCR template (mmedic-app-template therapies popup).
const IO_SITE_PATTERNS = [
  { site: 'FE', regex: /Femoral/i },
  { site: 'HU', regex: /Humeral/i },
  { site: 'TA', regex: /Tibia/i },
];

export default {
  name: 'IOVascularAccessLocation',
  props: {
    value: {
      type: [String, Number],
    },
    label: {
      type: String,
    },
    field: {
      type: Object,
      required: true,
    },
    ioSite: {
      type: [String, Number],
      default: null,
    },
  },

  computed: {
    textValue: {
      get() {
        return this.value;
      },
      set(value) {
        const updateValue = value === undefined ? null : value;
        this.$emit('input', updateValue);
      },
    },
    selectItems() {
      if (!this.field.values) {
        return [];
      }
      return _.reduce(this.field.values, (items, name, code) => {
        // Without a selected IO Site keep every option available so the
        // existing value still resolves and the field stays editable.
        if (!this.ioSite || this.siteOf(name) === this.ioSite) {
          items.push({
            text: (this.field.displayValue ? `${code} - ` : '') + name,
            value: code,
          });
        }
        return items;
      }, []);
    },
  },

  watch: {
    ioSite(newSite) {
      if (this.value === null || this.value === undefined) {
        return;
      }
      const name = this.field.values ? this.field.values[this.value] : null;
      // Only clear when we can positively confirm the current location
      // belongs to another site (avoid wiping values we can't classify).
      if (name && this.siteOf(name) !== newSite) {
        this.$emit('input', null);
      }
    },
  },

  methods: {
    siteOf(name) {
      const match = IO_SITE_PATTERNS.find(pattern => pattern.regex.test(name));
      return match ? match.site : null;
    },
  },
};
</script>
